<template>
  <v-toolbar :height="($vuetify.breakpoint.xsOnly && $route.query.displayStyle == 'map') ? '0' : '120px'"
             :scroll-toolbar-off-screen="$vuetify.breakpoint.xsOnly"
             :scroll-threshold="170"
             color="white"
             extension-height="50px"
             style="z-index: 10;"
             extended
             app
             clipped-right class="mx-0 px-0">
    <v-card flat color="white">
      <span class="hidden-xs-only pl-2">&nbsp;</span>
      <img alt="OEL Header Image" class="oelHeaderImage" src="~assets/images/dellogo.png" style="max-height: 80px; max-width: 90vw;">
      <span class="hidden-xs-only pr-2">&nbsp;</span>
    </v-card>
    <v-spacer />
    <v-card flat color="white" class="custom-hide" style="max-width: calc(100vw - 400px); text-align: center">
      <v-btn small href="http://www.floridaearlylearning.com/" flat color="blue darken-2" class="mx-0" target="_blank">
        <nt-icon>launch</nt-icon><span style="text-transform:none; padding-left: 10px">Division of Early Learning Website</span>
      </v-btn>
      <div v-if="isAuthenticated">
        <h2>Hello, {{ user.name }}</h2>
        {{ user.roles.join(', ') }}
      </div>
    </v-card>
    <div slot="extension" style="width: 100%">
      <div v-if="!isProdEnv" class="non-prod-banner">
         {{env}} environment
      </div>
      <v-toolbar fill-height color="purple darken-3" dark height="50px">
        <v-spacer />
        <span class="hidden-sm-and-up">
          <v-menu bottom left attach>
            <v-btn slot="activator" icon dark>
              <nt-icon>more_vert</nt-icon>
            </v-btn>
            <v-list style="overflow-y: auto; max-height: 77vh">
              <template v-for="(item, i) in navItems">
                <v-list-tile v-if="!item.children"
                             :key="i"
                             :to="item.url">
                  <v-list-tile-action>
                    <nt-icon>{{ item.icon }}</nt-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
                <v-list-group v-if="item.children"
                              :key="i"
                              :prepend-icon="item.icon"
                              exact
                              @click.stop.prevent>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                  <v-list-tile v-for="(childItem, i2) in item.children"
                               :key="`mc${i2}`"
                               :to="childItem.url"
                               no-action
                               exact>
                    <v-list-tile-action>
                      <v-icon>{{ childItem.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ childItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </template>
              <v-divider />
              <v-list-tile v-if="!isAuthenticated" @click="showLogin()">
                <v-list-tile-action>
                  <nt-icon>lock</nt-icon>
                </v-list-tile-action>
                <v-list-tile-title>Secure Area Login</v-list-tile-title>
              </v-list-tile>
              <!-- TODO: Implement User Profile
            <v-list-tile v-if="isAuthenticated" to="/profile">
            <v-list-tile-action>
              <nt-icon>person</nt-icon>
            </v-list-tile-action>
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>-->
              <v-list-tile v-if="isAuthenticated" @click="changePwdDlg = true">
                <v-list-tile-action>
                  <nt-icon>vpn_key</nt-icon>
                </v-list-tile-action>
                <v-list-tile-title>Change Password</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="isAuthenticated" @click="$logout(true)">
                <v-list-tile-action>
                  <nt-icon>exit_to_app</nt-icon>
                </v-list-tile-action>
                <v-list-tile-title>Logout of Secure Area</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </span>
        <v-toolbar-items class="hidden-xs-only">
          <scroll-close v-for="(item, i) in navItems" :key="i">
            <v-menu v-if="item.children" offset-y left>
              <v-btn slot="activator" :class="$route.path.indexOf('/' + item.label.toLowerCase()) === 0 ? 'v-btn--active' : ''" flat>
                {{ item.title }} <nt-icon class="ml-1">expand_more</nt-icon>
              </v-btn>
              <v-list>
                <v-list-tile v-for="(childItem, i2) in item.children"
                             :key="`c${i2}`"
                             :to="childItem.url"
                             exact>
                  <v-list-tile-action>
                    <nt-icon>{{ childItem.icon }}</nt-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ childItem.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-tooltip v-else top>
              <v-btn slot="activator" :to="item.url" flat>{{ item.label }}</v-btn>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </scroll-close>
          <scroll-close v-if="!isAuthenticated">
            <v-tooltip top>
              <v-btn slot="activator" flat @click="showLogin()"><nt-icon>lock</nt-icon>&nbsp;login</v-btn>
              <span>Secure Area Login</span>
            </v-tooltip>
          </scroll-close>
          <v-menu v-if="isAuthenticated" offset-y left>
            <v-btn slot="activator" icon dark>
              <nt-icon>person</nt-icon>
            </v-btn>
            <v-list>
              <!-- TODO: Implement User Profile
            <v-list-tile to="/profile">
            <v-list-tile-action>
              <nt-icon>person</nt-icon>
            </v-list-tile-action>
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>-->
              <v-list-tile @click="changePwdDlg = true">
                <v-list-tile-action>
                  <nt-icon>vpn_key</nt-icon>
                </v-list-tile-action>
                <v-list-tile-title>Change Password</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$logout(true)">
                <v-list-tile-action>
                  <nt-icon>exit_to_app</nt-icon>
                </v-list-tile-action>
                <v-list-tile-title>Logout of Secure Area</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
    </div>
    <login-dialog v-model="loginDlg" />
    <change-password-dialog v-model="changePwdDlg" />
  </v-toolbar>
</template>

<script>
  import loginDialog from 'components/auth/login-dialog'
  import changePasswordDialog from 'components/auth/change-password'

  import onDeckEvents from 'components/arrp/dashboard/possibleOnDeckEvents.js'

  export default {
    components: { loginDialog, changePasswordDialog },
    data: () => ({
      loginDlg: false,
      changePwdDlg: false
    }),
    computed: {
      isAuthenticated() {
        return this.$auth();
      },
      onDeckEvent() {
        const eventName = this.$store.getters['timeline/getOnDeckEvent'];
        return eventName && onDeckEvents[eventName];
      },
      user: function () {
        return this.$store.state.user;
      },
      env: function () {
        return process.env.BUILD_TARGET
      },
      isProdEnv: function () {
        return !(process.env.BUILD_TARGET === 'development' || process.env.BUILD_TARGET === 'staging');
      },
      navItems: function () {
        const ret = [];
        for (const route of this.$router.options.routes) {
          const ok =
            // route has meta, nav and...
            route.meta && route.meta.nav &&
            // filter by onDeckEvent
            (!route.meta.events || route.meta.events.includes(this.onDeckEvent)) &&
            // Doesn't require authentication, or is authorized
            (!route.meta.auth || route.meta.auth(this.$auth));

          if (ok) {
            const nav = route.meta.nav;
            if (nav.menu) {
              if (!ret.find(x => x.label === nav.menu)) {
                ret.push({
                  label: nav.menu,
                  title: nav.menu,
                  children: []
                })
              }

              ret.find(x => x.label === nav.menu).children.push({ url: route.path, ...nav });
            } else {
              ret.push({ url: route.path, ...nav });
            }
          }
        }
        return ret;
      }
    },
    watch: {
      isAuthenticated(val) {
        if (val === true && this.$auth([this.$roles.arrpAdmin, this.$roles.arrpAnalyst, this.$roles.arrpViewer])) {
          this.getOnDeckEvent();
        }
      }
    },
    created() {
      if (this.isAuthenticated) {
        this.getOnDeckEvent();
      }
      window.addEventListener('keyup', this.keyupEvent);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.keyupEvent);
    },
    methods: {
      keyupEvent(evt) {
        if (evt && evt.ctrlKey && evt.altKey === true && (evt.keyCode === 76 || evt.code === 'KeyL')) {
          this.showLogin();
        }
      },
      showLogin() {
        if (!this.isAuthenticated) {
          this.loginDlg = true;
        }
      },
      getOnDeckEvent() {
        return this.$store.dispatch('timeline/getOnDeckEvent')
      }
    }
  }
</script>

<style>
  .non-prod-banner {
    color: white;
    background-color: red;
    text-align: center;
  }
</style>
